import { MAIN_SITE_HOMEPAGE } from 'config';
import { Translate } from 'react-localize-redux';
import pokerstarsErrorImg from '../../images/background/oops_ps_logo.png';
import {
  ContactButton,
  ErrorImage,
  ErrorPageContent,
  ErrorPageText,
  ErrorPageWrapper,
  SubTitle,
  Title,
} from './style/errorPage.style';

// Note that unlike other pages, we load the ErrorPage with the main bundle,
// hence no *.loadable, because it has to be always **available**
// even if there's no connection.
const ErrorPage = () => {
  return (
    <ErrorPageWrapper>
      <ErrorPageContent>
        <ErrorImage src={pokerstarsErrorImg} alt="Work in progress" />
        <ErrorPageText>
          <Title>
            <Translate id="text.errorPage.title" />
          </Title>
          <SubTitle>
            <Translate id="text.errorPage.subTitle" />
          </SubTitle>
          <ContactButton
            onClick={() =>
              (window.location.href = `${MAIN_SITE_HOMEPAGE}contatti`)
            }
          >
            <Translate id="text.contactUs" />
          </ContactButton>
        </ErrorPageText>
      </ErrorPageContent>
    </ErrorPageWrapper>
  );
};

export default ErrorPage;
